import Suggester from "./Suggester";
import Filter from "./Filter";

if (document.getElementById('findologic_suggester')) {
    new Suggester('#findologic_suggester')
}

if (document.getElementById('findologic_filters')) {
    new Filter('#findologic_filters')
}

if (document.getElementById('findologic_activevalues')) {
    new Filter('#findologic_activevalues')
}

if (document.getElementById('findologic_activevalues_mobile')) {
    new Filter('#findologic_activevalues_mobile')
}
